module.exports = __webpack_public_path__ + "static/media/leadpages6.f144fe79.png";